function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import hideVisually from 'polished/lib/mixins/hideVisually';
import rgba from 'polished/lib/color/rgba';
import useTableContext from '../table/use_table_context';
var useStyles = _ref => {
  var {
    selected,
    variant
  } = _ref;
  var {
    loading,
    theme
  } = useTableContext();
  return React.useMemo(() => {
    var bodyRow = variant === 'body';
    var isHc = theme.mode === 'contrast';
    var evenColors = {
      background: theme.palette.background.container,
      border: theme.palette.primary.hover,
      hcBackground: theme.palette.primary.default,
      hcHover: theme.palette.primary.hover,
      interaction: theme.palette.primary.backgroundLight
    };
    var oddColors = {
      background: theme.palette.neutral.backgroundLight,
      border: theme.palette.primary.hover,
      hcBackground: theme.palette.primary.default,
      hcHover: theme.palette.primary.hover,
      interaction: theme.palette.primary.background
    };
    var getHoverRowColors = rowType => _objectSpread({
      backgroundColor: rowType.interaction
    }, isHc && {
      backgroundColor: rgba(rowType.hcHover, 0.1),
      borderColor: rowType.border,
      '& + tr': {
        borderTopColor: rowType.border
      }
    });
    var getSelectedRowColors = rowType => _objectSpread({
      backgroundColor: rowType.background
    }, selected && _objectSpread({
      backgroundColor: rowType.interaction,
      borderColor: rowType.border
    }, isHc && {
      backgroundColor: rgba(rowType.hcBackground, 0.1),
      borderColor: rowType.hcBackground,
      '& + tr': {
        borderTopColor: rowType.hcBackground
      },
      '&:hover': !loading && {
        backgroundColor: "".concat(rgba(rowType.hcHover, 0.1), "!important"),
        borderColor: "".concat(rowType.border, "!important"),
        '& + tr': {
          borderTopColor: "".concat(rowType.border, "!important")
        }
      }
    }));
    return _objectSpread({
      display: 'table-row',
      outline: 0,
      position: 'relative',
      verticalAlign: 'middle'
    }, bodyRow && _objectSpread(_objectSpread({
      // Even rows
      '&:hover': !loading && !selected && _objectSpread(_objectSpread({}, getHoverRowColors(evenColors)), {}, {
        '> td > span': {
          '> .vn-table__avatar': _objectSpread({}, hideVisually()),
          '> .vn-table__checkbox, > span .vn-table__checkbox': {
            clip: 'auto',
            clipPath: 'none',
            height: 'auto',
            overflow: 'visible',
            position: 'static',
            width: 'auto',
            whiteSpace: 'inherit'
          }
        }
      })
    }, getSelectedRowColors(evenColors)), {}, {
      // Odd rows
      '&:nth-of-type(2n+1)': _objectSpread(_objectSpread({}, getSelectedRowColors(oddColors)), {}, {
        '&:hover': !loading && !selected && _objectSpread({}, getHoverRowColors(oddColors))
      })
    }, isHc && {
      borderColor: theme.palette.foreground.default,
      borderStyle: 'solid',
      borderWidth: '1px 0 0',
      // Even rows
      '&:nth-of-type(2n)': {
        borderColor: selected ? theme.palette.primary.default : undefined
      },
      '&:last-of-type': {
        borderWidth: '1px 0 0 0'
      }
    }));
  }, [loading, selected, theme, variant]);
};
export default useStyles;